import { render, staticRenderFns } from "./kanban.vue?vue&type=template&id=42190f6b&scoped=true"
import script from "./kanban.vue?vue&type=script&lang=ts"
export * from "./kanban.vue?vue&type=script&lang=ts"
import style0 from "./kanban.vue?vue&type=style&index=0&id=42190f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42190f6b",
  null
  
)

export default component.exports